export enum OperacijeEnum {
    OP_RP_ADMINISTRIRANJE = 'Administriranje rečnika pojmova',
    OP_RP_OBJAVLJIVANJE_POJMA = 'Objavljivanje pojma iz rečnika najvišeg nivoa',
    OP_RP_IZMENA_POJMA = 'Izmena pojma iz rečnika najvišeg nivoa',
    OP_RP_ADMIN_TIPOVA_PODATAKA = 'Administriranje tipova podataka',
    OP_ADMIN_KLASIFIKACIJA = 'Administriranje klasifikacija',
    OP_SE_UNOS_SE = 'Unos službene evidencije',
    OP_SE_OBJAVA_SE = 'Objavljivanje službene evidencije',
    OP_SE_IZMENA_SE = 'Izmena podataka službene evidencije u pripremi',
    OP_SE_NOVA_VERZIJA_SE = 'Izmena objavljenih podataka službene evidencije',
    OP_SE_BRISANJE_SE = 'Brisanje službene evidencije u pripremi',
    OP_SE_DEAKTIVIRANJE_SE = 'Deaktiviranje službene evidencije',
    OP_SE_REAKTIVIRANJE_SE = 'Reaktiviranje službene evidencije',
    OP_SE_UNOS_SADRZAJA = 'Unos sadržaja službene evidencije',
    OP_SE_OBJAVA_SADRAJA  ='Objavljivanje sadržaja službene evidencije',
    OP_SE_IZMENA_SADRZAJA = 'Izmena sadržaja službene evidencije u pripremi',
    OP_SE_NOVA_VERZIJA_SADRZAJA = 'Izmena objavljenog sadržaja službene evidencije',
    OP_SE_BRISANJE_SADRZAJA = 'Brisanje sadržaja službene evidencije u pripremi',
    OP_SE_DEAKTIVIRANJE_SADRZAJA = 'Deaktiviranje sadržaja službene evidencije',
    OP_SE_REAKTIVIRANJE_SADRZAJA = 'Reaktiviranje sadržaja službene evidencije',
    OP_SE_PRETRAZIVANJE_SE_IZ_NADLEZNOSTI = 'Pretraživanje službenih evidencija iz nadležnosti',
    OP_PRETRAGA_METAREGISTRA = 'Pretraživanje Metaregistra',
}